var map = {
	"./skin1/pay_add_selecled@3x.png": "621a",
	"./skin2/pay_add_selecled@3x.png": "a224",
	"./skin3/pay_add_selecled@3x.png": "83f8",
	"./skin4/pay_add_selecled@3x.png": "dcad",
	"./skin5/pay_add_selecled@3x.png": "cb3e",
	"./skin6/pay_add_selecled@3x.png": "5786"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fad";